<template>
  <MmoCategoryPage v-if="currentGameSlug === 'world-of-warcraft-boost'" />
  <NestCategoryPage v-if="currentGameSlug === 'path-of-exile-2-boost'" />
</template>

<script setup>
import MmoCategoryPage from "~/components/page/category-page/MmoCategoryPage.vue";
import NestCategoryPage from "~/components/page/category-page/NestCategoryPage.vue";
const { currentGameSlug } = useGameComposable();

definePageMeta({
  layout: "default",
  pageInfo: {
    name: "mmo-boosting-game-page",
  },
});
</script>
